function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Header from './Header';
import Body from './Body';
import Footer from './Footer';
import { Title } from './elements';
/**
 * A Kpi Chart is a bar chart with a title
 *
 * @param {node} children
 * @param {string} className // Class needed by styled component.
 *
 * @return {jsx}
 */

var KpiChart = /*#__PURE__*/function (_PureComponent) {
  _inherits(KpiChart, _PureComponent);

  var _super = _createSuper(KpiChart);

  function KpiChart() {
    _classCallCheck(this, KpiChart);

    return _super.apply(this, arguments);
  }

  _createClass(KpiChart, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, children);
    }
  }]);

  return KpiChart;
}(PureComponent);
/** Prop types. */


_defineProperty(KpiChart, "Header", Header);

_defineProperty(KpiChart, "Body", Body);

_defineProperty(KpiChart, "Footer", Footer);

_defineProperty(KpiChart, "Title", Title);

KpiChart.propTypes = {
  /**
   * Anything that can be rendered: numbers, strings, elements or an array (or fragment).
   */
  children: PropTypes.node,

  /**
   * ClassName needed by styled components
   */
  className: PropTypes.string,

  /**
   * If true, narrows the padding of the component and the font-size of the title
   */
  // eslint-disable-next-line react/no-unused-prop-types
  isCompacted: PropTypes.bool
};
/** Default props. */

KpiChart.defaultProps = {
  children: null,
  className: '',
  isCompacted: false
};
export default styled(KpiChart).withConfig({
  displayName: "KpiChart",
  componentId: "sc-1j9wm3n-0"
})(["position:relative;display:flex;flex-direction:column;padding:", ";height:100%;border-radius:", ";border:1px solid ", ";background:", ";font-size:1.2rem;"], function (_ref) {
  var isCompacted = _ref.isCompacted;
  return isCompacted ? '1.2rem 1.6rem' : '2.4rem 3rem';
}, function (_ref2) {
  var dimensions = _ref2.theme.dimensions;
  return dimensions.radius;
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.lightGrey;
}, function (_ref4) {
  var palette = _ref4.theme.palette;
  return palette.white;
});